"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseValidateDto = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const case_type_enum_1 = require("./case-type.enum");
const case_pickup_validate_dto_1 = require("./case-pickup-validate.dto");
const case_return_request_enum_1 = require("./case-return-request.enum");
const MAX_LINE_ITEMS = 500;
class CaseValidateDto {
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Length)(18, 24),
    __metadata("design:type", String)
], CaseValidateDto.prototype, "accountId", void 0);
__decorate([
    (0, class_validator_1.IsIn)([case_type_enum_1.CaseType.Return, case_type_enum_1.CaseType.Warranty]),
    __metadata("design:type", String)
], CaseValidateDto.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(MAX_LINE_ITEMS),
    __metadata("design:type", Array)
], CaseValidateDto.prototype, "lines", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)([case_return_request_enum_1.CaseReturnRequestType.Label, case_return_request_enum_1.CaseReturnRequestType.Pickup]),
    __metadata("design:type", String)
], CaseValidateDto.prototype, "requestType", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Length)(2, 10),
    __metadata("design:type", String)
], CaseValidateDto.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((body) => !!(body === null || body === void 0 ? void 0 : body.pickup)),
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Type)(() => case_pickup_validate_dto_1.CasePickupValidateDto),
    __metadata("design:type", case_pickup_validate_dto_1.CasePickupValidateDto)
], CaseValidateDto.prototype, "pickup", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.MaxLength)(1000),
    __metadata("design:type", String)
], CaseValidateDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], CaseValidateDto.prototype, "parcelCount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], CaseValidateDto.prototype, "palletCount", void 0);
exports.CaseValidateDto = CaseValidateDto;
//# sourceMappingURL=case-validate.dto.js.map